// Sidebar de navegación principal.
// Las rutas reales se incorporan en tandas posteriores; por ahora todas
// apuntan a la HomeView salvo "Inicio".

import { html } from 'htm/preact'
import { Link } from 'preact-router/match'

const NAV_ITEMS = [
  { href: '/',             label: 'Inicio' },
  { href: '/inventario',   label: 'Inventario' },
  { href: '/clientes',     label: 'Por cliente' },
  { href: '/indicadores',  label: 'Indicadores' },
  { href: '/presentacion', label: 'Modo presentación' }
]

export function Sidebar() {
  return html`
    <aside class="layout__sidebar sidebar" aria-label="Navegación principal">
      <nav class="sidebar__nav">
        ${NAV_ITEMS.map(
          (item) => html`
            <${Link}
              key=${item.href}
              href=${item.href}
              class="sidebar__item"
              activeClassName="sidebar__item--active"
            >
              ${item.label}
            <//>
          `
        )}
      </nav>
      <div class="sidebar__footer">
        <${Link}
          href="/configuracion"
          class="sidebar__item"
          activeClassName="sidebar__item--active"
        >Configuración<//>
        <div class="sidebar__version">v0.1.0</div>
      </div>
    </aside>
  `
}
